import type { ModuleDefinition } from '../../../../app/moduleRegistry';

/** CMS: Slider — Master-GSA-only, gated behind `HasCmsB2C`. Scoped to a parent Site via
 *  `site_Id`. No longer a standalone routed page: `SliderListPage` now requires a `siteId`
 *  prop and is rendered directly as a tab inside `SiteDetailPage` (see
 *  ../site/pages/SiteDetailPage.tsx), so this sub-module contributes no route/menu item of
 *  its own — kept only so the sibling `cms/site` aggregator's import shape stays uniform. */
export const sliderModule: ModuleDefinition = {
  routes: [],
  menuItems: [],
};
